module.exports = __webpack_public_path__ + "static/admin-tools-image-26f1a46595692f96c5e26b067320a438.png";